import { request } from '@umijs/max';
import {
  ActionResultData,
  BatchDeletePayload2,
  BatchDisableBody3,
  BatchEnableBody2,
  BatchHiddenBody2,
  BatchSetOrderBody1,
  BatchShowBody2,
  OrgKindVo,
  PagerDataUmsOrgKind,
  SaveTagsBody3,
  SetOrderInput1,
  TagInfo,
  UmsOrgKind,
  UmsOrgKindNode,
  UmsOrgKindRequest,
  UploadVo,
} from '../AdminTypings';

export namespace AdminUmsOrgKind {
  /**
   * @summary 保存数据标签
   * @secure
   */
  export const saveTags = async (
    id: number,
    data: SaveTagsBody3,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/tag/save/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 设置排序权重
   * @secure
   */
  export const setOrder = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    data: SetOrderInput1,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/set/order/${memberType}/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 查询列表
   * @secure
   */
  export const query = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: UmsOrgKindRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<UmsOrgKind[]>(`/admin/ums/org/kind/query/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 分页列表
   * @secure
   */
  export const list = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: UmsOrgKindRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<PagerDataUmsOrgKind>(`/admin/ums/org/kind/list/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 编辑
   * @secure
   */
  export const edit = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    data: UmsOrgKind,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/edit/${memberType}/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 新建
   * @secure
   */
  export const create = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: UmsOrgKind,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/create/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量显示
   * @secure
   */
  export const batchShow = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: BatchShowBody2,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/batch/show/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量设置排序权重
   * @secure
   */
  export const batchSetOrder = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: BatchSetOrderBody1,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/batch/set/order/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量隐藏
   * @secure
   */
  export const batchHidden = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: BatchHiddenBody2,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/batch/hidden/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量启用
   * @secure
   */
  export const batchEnable = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: BatchEnableBody2,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/batch/enable/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量禁用
   * @secure
   */
  export const batchDisable = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: BatchDisableBody3,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/batch/disable/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量删除
   * @secure
   */
  export const batchDelete = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    data: BatchDeletePayload2,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/batch/delete/${memberType}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 类型树
   * @secure
   */
  export const treeNode = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    params: { [key: string]: any } = {},
  ) => {
    return request<UmsOrgKindNode[]>(`/admin/ums/org/kind/tree/${memberType}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据可用标签
   * @secure
   */
  export const getTagList = async (id: number, params: { [key: string]: any } = {}) => {
    return request<TagInfo[]>(`/admin/ums/org/kind/tag/list/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据标签
   * @secure
   */
  export const getTags = async (id: number, params: { [key: string]: any } = {}) => {
    return request<string[]>(`/admin/ums/org/kind/tag/get/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态 tree
   * @secure
   */
  export const staticTree = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo>(`/admin/ums/org/kind/static/tree/${memberType}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示
   * @secure
   */
  export const show = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/show/${memberType}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 类型路径 [BY ID]
   * @secure
   */
  export const kindPathById = async (id: number, params: { [key: string]: any } = {}) => {
    return request<UmsOrgKind[]>(`/admin/ums/org/kind/path/by/id/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 类型路径 [BY CODE]
   * @secure
   */
  export const kindPathByCode = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    return request<UmsOrgKind[]>(`/admin/ums/org/kind/path/by/code/${memberType}/${code}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 类型信息 [BY ID]
   * @secure
   */
  export const kindInfoById = async (id: number, params: { [key: string]: any } = {}) => {
    return request<OrgKindVo>(`/admin/ums/org/kind/info/by/id/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 类型信息 [BY CODE]
   * @secure
   */
  export const kindInfoByCode = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    code: string,
    params: { [key: string]: any } = {},
  ) => {
    return request<OrgKindVo>(`/admin/ums/org/kind/info/by/code/${memberType}/${code}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 隐藏
   * @secure
   */
  export const hidden = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/hidden/${memberType}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 启用
   * @secure
   */
  export const enable = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/enable/${memberType}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 禁用
   * @secure
   */
  export const disable = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/disable/${memberType}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 详情
   * @secure
   */
  export const detail = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<UmsOrgKind>(`/admin/ums/org/kind/detail/${memberType}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 删除
   * @secure
   */
  export const remove = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/delete/${memberType}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 整理数据
   * @secure
   */
  export const collate = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/collate/${memberType}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 缓存 tree
   * @secure
   */
  export const cacheTree = async (
    memberType: 'none' | 'admin' | 'tenant' | 'merchant' | 'consumer' | 'api',
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/ums/org/kind/cache/tree/${memberType}`, {
      method: 'GET',
      ...params,
    });
  };
}

export default AdminUmsOrgKind;

export const saveTags = AdminUmsOrgKind.saveTags;
export const setOrder = AdminUmsOrgKind.setOrder;
export const query = AdminUmsOrgKind.query;
export const list = AdminUmsOrgKind.list;
export const edit = AdminUmsOrgKind.edit;
export const create = AdminUmsOrgKind.create;
export const batchShow = AdminUmsOrgKind.batchShow;
export const batchSetOrder = AdminUmsOrgKind.batchSetOrder;
export const batchHidden = AdminUmsOrgKind.batchHidden;
export const batchEnable = AdminUmsOrgKind.batchEnable;
export const batchDisable = AdminUmsOrgKind.batchDisable;
export const batchDelete = AdminUmsOrgKind.batchDelete;
export const treeNode = AdminUmsOrgKind.treeNode;
export const getTagList = AdminUmsOrgKind.getTagList;
export const getTags = AdminUmsOrgKind.getTags;
export const staticTree = AdminUmsOrgKind.staticTree;
export const show = AdminUmsOrgKind.show;
export const kindPathById = AdminUmsOrgKind.kindPathById;
export const kindPathByCode = AdminUmsOrgKind.kindPathByCode;
export const kindInfoById = AdminUmsOrgKind.kindInfoById;
export const kindInfoByCode = AdminUmsOrgKind.kindInfoByCode;
export const hidden = AdminUmsOrgKind.hidden;
export const enable = AdminUmsOrgKind.enable;
export const disable = AdminUmsOrgKind.disable;
export const detail = AdminUmsOrgKind.detail;
export const remove = AdminUmsOrgKind.remove;
export const collate = AdminUmsOrgKind.collate;
export const cacheTree = AdminUmsOrgKind.cacheTree;
